<template>
	<div class="container pb_0">
		<div class="main type_01">
			<p class="text_t type1">
				{{ $t('rtr_business-asset-pay.title1') }}
			</p>
			<p class="text_n">
				{{ $t('rtr_business-asset-pay.text1') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.signup') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box mb_16">
					<div class="bg_text_area center tac">
						<p class="text_t fc_white">
							{{ $t('rtr_business-asset-pay.title2') }}
							{{ $t('rtr_business-asset-pay.title3') }}
						</p>
						<p class="text_n fc_white">
							{{ $t('rtr_business-asset-pay.text2') }}
						</p>
					</div>
				</div>

				<div class="bg_box">
					<div class="bg_text_area tac pt_100">
						<p class="text_t mb_30">
							{{ $t('rtr_business-asset-pay.title4') }}
							{{ $t('rtr_business-asset-pay.title5') }}
						</p>
						<p class="text_n">
							{{ $t('rtr_business-asset-pay.text3') }}
							{{ $t('rtr_business-asset-pay.text4') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Pay.vue',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
